var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/Common/ClientItem/ClientItem.jinja"] = require( "front/components/Common/ClientItem/ClientItem.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/IllustrationsClients/IllustrationsClients.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/IllustrationsClients/IllustrationsClients.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/IllustrationsClients/IllustrationsClients.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += "\n\n";
env.getTemplate("front/components/Common/ClientItem/ClientItem.jinja", false, "assets/app/front/pages/IllustrationsClients/IllustrationsClients.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "ClientItem")) {
var t_10 = t_7.ClientItem;
} else {
cb(new Error("cannot import 'ClientItem'")); return;
}
context.setVariable("ClientItem", t_10);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
output += t_13;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
context.getSuper(env, "title", b_title, frame, runtime, function(t_15,hole_40) {
if(t_15) { cb(t_15); return; }
hole_40 = runtime.markSafe(hole_40);
output += runtime.suppressValue(hole_40, env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 5, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Bang! Bang! • Клиент"])), env.opts.autoescape);
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"IllustrationsClients\">\n        ";
var t_16;
t_16 = "illustrations";
frame.set("mods", t_16, true);
if(frame.topLevel) {
context.setVariable("mods", t_16);
}
if(frame.topLevel) {
context.addExport("mods", t_16);
}
output += "\n        ";
output += runtime.suppressValue((lineno = 10, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"includeComponent"), "macros[\"includeComponent\"]", context, ["front/components/Common/TopBar/TopBar.jinja",[],runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "mods"),"caller": (function (){var macro_t_17 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_18 = "";;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
output += "\n\n        <div class=\"IllustrationsClients-wrapper\">\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "advertisingAgencies")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 15, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Рекламные агентства"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_21 = runtime.contextOrFrameLookup(context, frame, "advertisingAgencies");
if(t_21) {t_21 = runtime.fromIterator(t_21);
var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("item", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
output += "\n                            ";
output += runtime.suppressValue((lineno = 18, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_22,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "finance")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 25, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Финансы"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_25 = runtime.contextOrFrameLookup(context, frame, "finance");
if(t_25) {t_25 = runtime.fromIterator(t_25);
var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("item", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\n                            ";
output += runtime.suppressValue((lineno = 28, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_26,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "marketplace")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 35, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Маркетплейс"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_29 = runtime.contextOrFrameLookup(context, frame, "marketplace");
if(t_29) {t_29 = runtime.fromIterator(t_29);
var t_28 = t_29.length;
for(var t_27=0; t_27 < t_29.length; t_27++) {
var t_30 = t_29[t_27];
frame.set("item", t_30);
frame.set("loop.index", t_27 + 1);
frame.set("loop.index0", t_27);
frame.set("loop.revindex", t_28 - t_27);
frame.set("loop.revindex0", t_28 - t_27 - 1);
frame.set("loop.first", t_27 === 0);
frame.set("loop.last", t_27 === t_28 - 1);
frame.set("loop.length", t_28);
output += "\n                            ";
output += runtime.suppressValue((lineno = 38, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_30,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "food")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 45, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Еда"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_33 = runtime.contextOrFrameLookup(context, frame, "food");
if(t_33) {t_33 = runtime.fromIterator(t_33);
var t_32 = t_33.length;
for(var t_31=0; t_31 < t_33.length; t_31++) {
var t_34 = t_33[t_31];
frame.set("item", t_34);
frame.set("loop.index", t_31 + 1);
frame.set("loop.index0", t_31);
frame.set("loop.revindex", t_32 - t_31);
frame.set("loop.revindex0", t_32 - t_31 - 1);
frame.set("loop.first", t_31 === 0);
frame.set("loop.last", t_31 === t_32 - 1);
frame.set("loop.length", t_32);
output += "\n                            ";
output += runtime.suppressValue((lineno = 48, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_34,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "company")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 55, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Компании"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_37 = runtime.contextOrFrameLookup(context, frame, "company");
if(t_37) {t_37 = runtime.fromIterator(t_37);
var t_36 = t_37.length;
for(var t_35=0; t_35 < t_37.length; t_35++) {
var t_38 = t_37[t_35];
frame.set("item", t_38);
frame.set("loop.index", t_35 + 1);
frame.set("loop.index0", t_35);
frame.set("loop.revindex", t_36 - t_35);
frame.set("loop.revindex0", t_36 - t_35 - 1);
frame.set("loop.first", t_35 === 0);
frame.set("loop.last", t_35 === t_36 - 1);
frame.set("loop.length", t_36);
output += "\n                            ";
output += runtime.suppressValue((lineno = 58, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_38,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "charitableFoundations")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 65, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Благотворительные фонды"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_41 = runtime.contextOrFrameLookup(context, frame, "charitableFoundations");
if(t_41) {t_41 = runtime.fromIterator(t_41);
var t_40 = t_41.length;
for(var t_39=0; t_39 < t_41.length; t_39++) {
var t_42 = t_41[t_39];
frame.set("item", t_42);
frame.set("loop.index", t_39 + 1);
frame.set("loop.index0", t_39);
frame.set("loop.revindex", t_40 - t_39);
frame.set("loop.revindex0", t_40 - t_39 - 1);
frame.set("loop.first", t_39 === 0);
frame.set("loop.last", t_39 === t_40 - 1);
frame.set("loop.length", t_40);
output += "\n                            ";
output += runtime.suppressValue((lineno = 68, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_42,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "industrial")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 75, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Промышленность"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_45 = runtime.contextOrFrameLookup(context, frame, "industrial");
if(t_45) {t_45 = runtime.fromIterator(t_45);
var t_44 = t_45.length;
for(var t_43=0; t_43 < t_45.length; t_43++) {
var t_46 = t_45[t_43];
frame.set("item", t_46);
frame.set("loop.index", t_43 + 1);
frame.set("loop.index0", t_43);
frame.set("loop.revindex", t_44 - t_43);
frame.set("loop.revindex0", t_44 - t_43 - 1);
frame.set("loop.first", t_43 === 0);
frame.set("loop.last", t_43 === t_44 - 1);
frame.set("loop.length", t_44);
output += "\n                            ";
output += runtime.suppressValue((lineno = 78, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_46,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "sports")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 85, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Спорт"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_49 = runtime.contextOrFrameLookup(context, frame, "sports");
if(t_49) {t_49 = runtime.fromIterator(t_49);
var t_48 = t_49.length;
for(var t_47=0; t_47 < t_49.length; t_47++) {
var t_50 = t_49[t_47];
frame.set("item", t_50);
frame.set("loop.index", t_47 + 1);
frame.set("loop.index0", t_47);
frame.set("loop.revindex", t_48 - t_47);
frame.set("loop.revindex0", t_48 - t_47 - 1);
frame.set("loop.first", t_47 === 0);
frame.set("loop.last", t_47 === t_48 - 1);
frame.set("loop.length", t_48);
output += "\n                            ";
output += runtime.suppressValue((lineno = 88, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_50,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "art")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 95, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Арт"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_53 = runtime.contextOrFrameLookup(context, frame, "art");
if(t_53) {t_53 = runtime.fromIterator(t_53);
var t_52 = t_53.length;
for(var t_51=0; t_51 < t_53.length; t_51++) {
var t_54 = t_53[t_51];
frame.set("item", t_54);
frame.set("loop.index", t_51 + 1);
frame.set("loop.index0", t_51);
frame.set("loop.revindex", t_52 - t_51);
frame.set("loop.revindex0", t_52 - t_51 - 1);
frame.set("loop.first", t_51 === 0);
frame.set("loop.last", t_51 === t_52 - 1);
frame.set("loop.length", t_52);
output += "\n                            ";
output += runtime.suppressValue((lineno = 98, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_54,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "technology")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 105, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Технологии"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_57 = runtime.contextOrFrameLookup(context, frame, "technology");
if(t_57) {t_57 = runtime.fromIterator(t_57);
var t_56 = t_57.length;
for(var t_55=0; t_55 < t_57.length; t_55++) {
var t_58 = t_57[t_55];
frame.set("item", t_58);
frame.set("loop.index", t_55 + 1);
frame.set("loop.index0", t_55);
frame.set("loop.revindex", t_56 - t_55);
frame.set("loop.revindex0", t_56 - t_55 - 1);
frame.set("loop.first", t_55 === 0);
frame.set("loop.last", t_55 === t_56 - 1);
frame.set("loop.length", t_56);
output += "\n                            ";
output += runtime.suppressValue((lineno = 108, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_58,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "media")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 115, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Медиа"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_61 = runtime.contextOrFrameLookup(context, frame, "media");
if(t_61) {t_61 = runtime.fromIterator(t_61);
var t_60 = t_61.length;
for(var t_59=0; t_59 < t_61.length; t_59++) {
var t_62 = t_61[t_59];
frame.set("item", t_62);
frame.set("loop.index", t_59 + 1);
frame.set("loop.index0", t_59);
frame.set("loop.revindex", t_60 - t_59);
frame.set("loop.revindex0", t_60 - t_59 - 1);
frame.set("loop.first", t_59 === 0);
frame.set("loop.last", t_59 === t_60 - 1);
frame.set("loop.length", t_60);
output += "\n                            ";
output += runtime.suppressValue((lineno = 118, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_62,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "publishingHouses")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 125, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Издательские дома"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_65 = runtime.contextOrFrameLookup(context, frame, "publishingHouses");
if(t_65) {t_65 = runtime.fromIterator(t_65);
var t_64 = t_65.length;
for(var t_63=0; t_63 < t_65.length; t_63++) {
var t_66 = t_65[t_63];
frame.set("item", t_66);
frame.set("loop.index", t_63 + 1);
frame.set("loop.index0", t_63);
frame.set("loop.revindex", t_64 - t_63);
frame.set("loop.revindex0", t_64 - t_63 - 1);
frame.set("loop.first", t_63 === 0);
frame.set("loop.last", t_63 === t_64 - 1);
frame.set("loop.length", t_64);
output += "\n                            ";
output += runtime.suppressValue((lineno = 128, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_66,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "journals")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 135, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Журналы"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_69 = runtime.contextOrFrameLookup(context, frame, "journals");
if(t_69) {t_69 = runtime.fromIterator(t_69);
var t_68 = t_69.length;
for(var t_67=0; t_67 < t_69.length; t_67++) {
var t_70 = t_69[t_67];
frame.set("item", t_70);
frame.set("loop.index", t_67 + 1);
frame.set("loop.index0", t_67);
frame.set("loop.revindex", t_68 - t_67);
frame.set("loop.revindex0", t_68 - t_67 - 1);
frame.set("loop.first", t_67 === 0);
frame.set("loop.last", t_67 === t_68 - 1);
frame.set("loop.length", t_68);
output += "\n                            ";
output += runtime.suppressValue((lineno = 138, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_70,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "musicBand")) > 0) {
output += "\n                <div class=\"IllustrationsClients-category isHide\" data-scroll data-scroll-offset=\"10\">\n                    <div class=\"IllustrationsClients-categoryTitle\">";
output += runtime.suppressValue((lineno = 145, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Музыкальные группы"])), env.opts.autoescape);
output += "</div>\n                    <div class=\"IllustrationsClients-categoryList\">\n                        ";
frame = frame.push();
var t_73 = runtime.contextOrFrameLookup(context, frame, "musicBand");
if(t_73) {t_73 = runtime.fromIterator(t_73);
var t_72 = t_73.length;
for(var t_71=0; t_71 < t_73.length; t_71++) {
var t_74 = t_73[t_71];
frame.set("item", t_74);
frame.set("loop.index", t_71 + 1);
frame.set("loop.index0", t_71);
frame.set("loop.revindex", t_72 - t_71);
frame.set("loop.revindex0", t_72 - t_71 - 1);
frame.set("loop.first", t_71 === 0);
frame.set("loop.last", t_71 === t_72 - 1);
frame.set("loop.length", t_72);
output += "\n                            ";
output += runtime.suppressValue((lineno = 148, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ClientItem"), "ClientItem", context, [t_74,runtime.contextOrFrameLookup(context, frame, "language"),"illustrations"])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/IllustrationsClients/IllustrationsClients.jinja"] , dependencies)